import { Component, OnInit, ChangeDetectorRef, Input } from '@angular/core';
import { Controllers } from '@shared/core/controllers';

import { TilesComponent } from '../../tiles.shared.component';

@Component({
    selector: 'shared-tile-for-promotion-item',
    templateUrl: './tile-for-promotion-item.shared.component.html',
    styleUrls: ['./tile-for-promotion-item.shared.component.scss']
})
export class TileForPromotionItemComponent extends TilesComponent implements OnInit {
    @Input() public item: APICommon.IPromotionItem;
    @Input() public layout: 'row' | 'column' = 'row';
    @Input() public isEven: boolean = false;

    constructor(
        public changeDetectorRef: ChangeDetectorRef,
        public controllers: Controllers,
    ) {
        super(changeDetectorRef, controllers);
    }

    ngOnInit(): void {
    }

    public get centerHeader(): boolean {
        return window.innerWidth < 768 || this.layout === 'row';
    }

    public get isLoading(): boolean {
        return !this.item || this.loading;
    }
}
